import React from 'react';
import { Button, Modal } from 'react-bootstrap'
import './MakePaymentModal.css';

const MakePaymentModal = ({ show, setShow, MakePayment, status }) => {
    // Closes modal
    const handleClose = () => {
        setShow(false);
    };

    // Calls the make payment method
    const handlePayment = () => {
        setShow(false);
        MakePayment();
    };

    return (
        <>
            <Modal
                className='modal-spacing'
                dialogClassName='taller-modal'
                show={show}
                onHide={handleClose}
            >
                <Modal.Header style={{ border: 'none' }}>
                    <p className="close-button" onClick={handleClose}>
                        CLOSE
                    </p>
                </Modal.Header>
                <Modal.Body>
                    <div className="quick-modal-body">
                        <div className="modal-body-content">
                            <p className="text-black">
                                You cannot enroll in or update Autopay as your policy is currently in {status} status.
                            </p>
                            <p className="text-black">
                                Please make a one time payment here for your overdue bill.
                            </p>
                            <button className="payment-button" onClick={handlePayment}>
                                Make a Payment
                            </button>
                            <p className="text-black font-bold my-2" style={{ textAlign: 'center' }}>
                                You can manage Autopay after your policy is no longer in {status}.
                            </p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default MakePaymentModal;
